// Setzt den gewünschten Dateinamen und öffnet den Download
export function openDownloadWithFilename(filename: string, content: Blob, target?: string) {
  if (!content) {
    console.error('content is ', content);
    return;
  } else if (!(content instanceof Blob)) {
    content = new Blob([content]);
  }

  const fileURL = URL.createObjectURL(content);

  const a = globalThis.document.createElement('a');
  globalThis.document.body.append(a);
  a.setAttribute('style', 'display: none');
  a.href = fileURL;
  a.download = filename;
  if (target) {
    a.target = target;
  }

  a.click();
  URL.revokeObjectURL(fileURL);
  a.remove();
}

export async function openDownloadForPromise(promise: Promise<{ blob: Blob; filename: string }>, target?: string) {
  const objectUrl = await promise;
  openDownloadWithFilename(objectUrl.filename, objectUrl.blob, target);
}

export function openDownloadForJson(filename: string, content: unknown) {
  const jsonStr = JSON.stringify(content, null, 2);
  openDownloadForString(filename, jsonStr);
}

export function openDownloadForString(filename: string, content: string) {
  const element = globalThis.document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  globalThis.document.body.append(element);

  element.click();

  element.remove();
}

/**
 * Öffnet einen Download Dialog für einen base64 codierten binären File
 *
 * Kann verwendet werden wenn binäre Files (z.B. zip, xls etc) als Base64 String als Resultat zusammen mit anderen Nutzdaten
 * über einen Request geliefert werden
 *fe
 * @param filename
 * @param fileAsBase64String
 * @param type
 */

export function openDownloadForBase64File(filename: string, fileAsBase64String: string, type = 'application/zip') {
  // Base64 string decoden um binary daten zu erhalten
  const binaryString = atob(fileAsBase64String);

  // Blob erzeugen
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type });

  openDownloadWithFilename(filename, blob);
}
